import React from 'react'
import { EmptyState } from '@enamelai/design-system'
import './FilesAndLettersEmptyState.css'

export type FilesAndLettersEmptyStateProps = {
  /** 'emptyFolder' = upload/drop, 'noPatient' = select a patient, 'results' = search/filter */
  variant?: 'emptyFolder' | 'noPatient' | 'results'
  onChooseFile?: () => void
  onDragOver?: (e: React.DragEvent) => void
  onDragLeave?: (e: React.DragEvent) => void
  onDrop?: (e: React.DragEvent) => void
  isDragOver?: boolean
  /** When variant is 'noPatient', called when user clicks Select a patient */
  onSelectPatient?: () => void
}

function FilesAndLettersEmptyState({
  variant = 'emptyFolder',
  onChooseFile,
  onDragOver,
  onDragLeave,
  onDrop,
  isDragOver = false,
  onSelectPatient,
}: FilesAndLettersEmptyStateProps): React.ReactElement {
  if (variant === 'noPatient') {
    return (
      <EmptyState
        className="files-and-letters-empty"
        iconClass="mgc mgc_folder_fill"
        title="No files found"
        description="Select a patient to view their files."
        actionLabel="Select a patient"
        onAction={onSelectPatient}
      />
    )
  }

  if (variant === 'results') {
    return (
      <EmptyState
        className="files-and-letters-empty"
        iconClass="mgc mgc_folder_fill"
        title="No files found"
        description="No files match your search."
      />
    )
  }

  return (
    <div
      className={`files-and-letters-empty-dropzone${isDragOver ? ' is-drag-over' : ''}`}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
    >
      <EmptyState
        className="files-and-letters-empty files-and-letters-empty--folder"
        iconClass="mgc mgc_folder_line"
        title="This folder is empty"
        description="Drag and drop or choose file from local device"
        actionLabel="Upload file"
        onAction={onChooseFile}
      />
    </div>
  )
}

export default FilesAndLettersEmptyState
